import { OrderFormValues } from '../../../../../typings'
import { Props } from './../../../typings'

import { RecurrenceSettingsField } from '../../../../../../../../components/RecurrenceSettings'

export function RecurrenceSettings(props: Props) {
  const { order } = props

  return (
    <RecurrenceSettingsField<'recurrenceSettings', OrderFormValues>
      name="recurrenceSettings"
      recurrenceSettingsFieldProps={{
        uiFramework: 'tidal',
        inEditMode: !!order,
      }}
    />
  )
}
